module.exports = __webpack_public_path__ + "fonts/display-regular.3f885d05.woff";